import { Methods } from "@newview/infrastructure";
import {NewviewOaBaseApi} from "./NewviewOaBaseApi";


export class DataSupplierInfoApi extends NewviewOaBaseApi {

  public get ControllerName(): any {
    return 'datasupplierInfo'
  }

}